<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002399')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter"
              inputType="textarea"
              :selectStyle="{width: '100px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1001522')">
              <local-tabButton :tabButtonList="statusList" @selectStatus="statusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001180')">
              <Date-picker
                type="datetimerange"
                :options="dateOptions"
                class="wid100P"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="createTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001579')" prop="carrierId">
              <Select v-model="pageParams.carrierId" filterable>
                <Option v-for="item in logisticsProviderData" :key="item.carrierId" :value="item.carrierId">{{ item.carrierName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1004044')" prop="handoverBy">
              <Select v-model="pageParams.handoverBy" filterable :placeholder="$t('key1004045')">
                <Option v-for="item in handoverList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <div class="sort_options_box mr15">
        <span>{{ $t('key1004046') }}</span>
        <Button-group>
          <Button :type="item.checked ? 'primary' : 'default'"
            v-for="item in sortData"
            @click="clickSortButton(item)"
            :key="item.value">{{ item.label }}
            <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
            <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
          </Button>
        </Button-group>
      </div>
      <Button type="primary" class="mr15" @click="markDeliveryBtn"
        v-if="getPermission('ymsCarrierHandoverOrder_updateDelivery')">{{ $t('key1004030') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="tableDom"
        highlight-row
        border
        max-height="510"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="getSelectValue">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="curPage"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--打印箱唛-->
    <printCaseMarkModal
      ref="printTalg"
      :apiUrl="apiUrl"
      :service="service"
      typeTalg="handoverSheetManage">
    </printCaseMarkModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import printCaseMarkModal from "@/components/common/printCaseMarkModal";
import dropDownFilter from "@/components/common/dropDownFilter.vue";
import {getUserNameByUserId, getEnableWarehouseData, getWarehouseName, getAllUsersInfo,
  getDataSetBatchList, getEnumList, getEnumName} from "@/utils/common";

export default {
  name: 'handoverSheetManage',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      createTime: [],
      selectTableData: [],
      apiUrl: api.put_ymsCarrierHandoverOrder_printCarrierHandoverOrder,
      service: 'yms-core-service',
      pageParams: {
        carrierId: 'null',
        status: null,
        createdStartTime: null,
        createdEndTime: null,
        ymsCarrierHandoverOrderNumbers: '',
        packageCodes: '',
        ymsWarehouseId: 'null',
        handoverBy: 'null',
        upDown: 'down',
        orderBy: 'createdTime',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      curPage: 1,
      pageParamsStatus: false,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004021'),
          key: 'ymsCarrierHandoverOrderNumber',
          align: 'center',
          minWidth: 140,
          fixed: 'left',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.ymsCarrierHandoverOrderNumber,
                styles: {
                  justifyContent: 'center'
                }
              },
              on: {
                AlinkBtn: () => {
                  v.$router.push({
                    path: '/handoverSheetManageDetails',
                    query: {
                      ymsCarrierHandoverOrderId: params.row.ymsCarrierHandoverOrderId
                    }
                  });
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000220'),
          key: 'carrierName',
          align: 'center',
          minWidth: 220,
          render(h, params) {
            let text = '';
            if (v.logisticsProviderData.length > 0) {
              v.logisticsProviderData.map((item) => {
                if (item.carrierId === params.row.carrierId) {
                  text = item.carrierName;
                }
              });
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222'),
          key: 'carrierShippingMethodName',
          align: 'center',
          minWidth: 220
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390'),
          key: 'warehouseName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.warehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004022'),
          minWidth: 110,
          key: 'packageQuantity',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          minWidth: 110,
          render(h, params) {
            let statusTxt = '';
            let status = params.row.status;
            v.statusList.map((item) => {
              if (item.value === status) {
                statusTxt = item.title;
              }
            });
            return h('div', statusTxt);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004023'),
          minWidth: 140,
          key: 'deliveryType',
          align: 'center',
          render(h, params) {
            let deliveryType = params.row.deliveryType;
            let text = getEnumName(v.enumData, 'DeliveryTypeEnum', deliveryType, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004024'),
          minWidth: 140,
          key: 'placeOrderType',
          align: 'center',
          render(h, params) {
            let placeOrderType = params.row.placeOrderType;
            let index = Number(placeOrderType);
            let list = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004025'), aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004026')];
            let text = list[index - 1] || '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004027'),
          minWidth: 150,
          key: 'logisticsTrackingNumber',
          align: 'center',
          render(h, params) {
            let placeOrderType = params.row.placeOrderType;
            let selfDeliveryTrackingNumber = params.row.selfDeliveryTrackingNumber || '-';
            let expressageNo = params.row.expressageNo || '-';
            let text = Number(placeOrderType) === 1 ? selfDeliveryTrackingNumber : Number(placeOrderType) === 2 ? expressageNo : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          minWidth: 170,
          sortable: true,
          render(h, params) {
            let createdTime = params.row.createdTime ? v.$uDate.dealTime(params.row.createdTime, 'fulltime') : '';
            return h('span', createdTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004028'),
          key: 'handoverTime',
          align: 'center',
          minWidth: 170,
          sortable: true,
          render(h, params) {
            let handoverTime = params.row.handoverTime ? v.$uDate.dealTime(params.row.handoverTime, 'fulltime') : '';
            return h('span', handoverTime);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004029'),
          key: 'handoverBy',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.handoverBy, v.userInfoList) || '-');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'opts',
          align: 'center',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let placeOrderType = params.row.placeOrderType;
            let status = params.row.status;
            let carrierCode = null;
            let carrierId = params.row.carrierId;
            let ymsCarrierHandoverOrderId = params.row.ymsCarrierHandoverOrderId;
            if (v.logisticsProviderData.length > 0) {
              v.logisticsProviderData.map((item) => {
                if (item.carrierId === carrierId) {
                  carrierCode = item.carrierCode;
                }
              });
            }
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsCarrierHandoverOrder_detail'),
                    clickFn: () => {
                      v.$router.push({
                        path: '/handoverSheetManageDetails',
                        query: {
                          ymsCarrierHandoverOrderId: ymsCarrierHandoverOrderId
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004030'),
                    show: params.row.status !== 1 && v.getPermission('ymsCarrierHandoverOrder_batchUpdateDelivery'),
                    clickFn: () => {
                      v.singleMarkOut(ymsCarrierHandoverOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001181'),
                    show: v.getPermission('ymsCarrierHandoverOrder_printCarrierHandoverOrder'),
                    clickFn: () => {
                      v.$refs['printTalg'].getPrintData(ymsCarrierHandoverOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004031'),
                    show: params.row.status === 2,
                    clickFn: () => {
                      v.$router.push('/sortingOut');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004032'),
                    show: carrierCode === 'aliexpress' && params.row.status !== 2,
                    clickFn: () => {
                      v.printPreDelivery(ymsCarrierHandoverOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004033'),
                    show: [0, 1].includes(status) && placeOrderType === 1, // 已装箱、已出库、系统下发
                    clickFn: () => {
                      let path = params.row.selfDeliveryLabelPath;
                      if (path) {
                        v.commonPrint(path, '1');
                      } else {
                        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004034'));
                        return false;
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004035'),
                    show: v.isAliExpressLogistics(params.row, 1), // 已装箱且是速卖通全托管虚拟物流
                    clickFn: () => {
                      v.appointmentCollection(ymsCarrierHandoverOrderId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004036'),
                    show: v.isAliExpressLogistics(params.row, 2), // 已装箱、已出库且是速卖通全托管虚拟物流
                    clickFn: () => {
                      v.printCollectionReceipt(ymsCarrierHandoverOrderId);
                    }
                  },
                ],
              },
              on: { // 动态设置操作的宽度
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      cacheClickVal: 'createdTime',
      sortData: [ // 排序数据
        {
          label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004037'),
          value: 'createdTime',
          checked: true,
          toogle: true
        }
      ],
      warehouseList: [],
      logisticsProviderData: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004021'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004038'), parameterKey: 'ymsCarrierHandoverOrderNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001248'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004039'), parameterKey: 'packageCodes'}
      ],
      defaultSelectValue: 1,
      handoverList: [],
      userInfoList: {},
      enumData: [],
      currentIndex: 0
    };
  },
  computed: {
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 状态
    statusList() {
      const ENUM_KEY = 'YmsCarrierHandoverOrderStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === this.currentIndex;
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      v.warehouseData = [];
      (async () => {
        let enumKeyList = ['YmsCarrierHandoverOrderStatusCoreEnum', 'DeliveryTypeEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await v.getLogisticsProvidersData();
        await getEnableWarehouseData(1).then((data) => {
          v.warehouseList = data;
          v.warehouseList.unshift({
            ymsWarehouseId: 'null',
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
          });
        });
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
          if (data) {
            v.getHandoverPersonData(data);
          }
        });
        await v.getList();
      })();
    },
    // 获取交接人数据
    getHandoverPersonData(userInfoList) {
      let v = this;
      v.handoverList = [];
      v.axios.get(api.get_ymsCarrierHandoverOrder_getHadnloverBys).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            let newList = [];
            if (userInfoList) {
              data.map((item) => {
                if (userInfoList[item]) {
                  newList.push({
                    userName: userInfoList[item].userName,
                    userId: userInfoList[item].userId,
                  });
                }
              });
            }
            v.handoverList = v.uniqueFunc(newList, 'userId');
            v.handoverList.unshift({
              userId: 'null',
              userName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
            });
          }
        }
      });
    },
    // 选取状态
    statusBtn(index, value) {
      this.pageParams.status = value;
      this.currentIndex = index;
    },
    // 获取创建时间
    getDateValue(value) { // 获取日期返回值
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.createdStartTime = null;
          v.pageParams.createdEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.createTime = v.defaultTimePeriod(value, false);
          v.pageParams.createdStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.createdEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置创建时间
    resetDate() {
      this.pageParams.createdStartTime = null;
      this.pageParams.createdEndTime = null;
    },
    // 查询按钮
    search() {
      this.curPage = 1;
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      if (v.getPermission('ymsCarrierHandoverOrder_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsCarrierHandoverOrder_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.updateTableDom('tableDom');
              v.total = data.total;
            } else {
              v.tableLoading = false;
            }
          } else {
            v.tableLoading = false;
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      // 处理默认参数为null
      let keyList = ['carrierId', 'ymsWarehouseId', 'handoverBy'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      // 处理默认参数为空数组
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      return params;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.statusBtn(0, null);
      v.$refs['pageParams'].resetFields();
      v.createTime = [];
      v.changeInput(1);
      v.resetDate();
      v.getList();
    },
    // 点击排序的按钮
    clickSortButton(data) {
      if (data.value === this.cacheClickVal) {
        data.toogle = !data.toogle;
      }
      this.cacheClickVal = data.value;
      if (data.toogle) {
        this.pageParams.upDown = 'down';
      } else {
        this.pageParams.upDown = 'up';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.pageParams.orderBy = data.value;
      this.pageParamsStatus = true;
    },
    // 获取列表勾选的数据
    getSelectValue(value) {
      this.selectTableData = value;
    },
    // 批量标记出库按钮
    markDeliveryBtn() {
      let v = this;
      let ymsCarrierHandoverOrderIds = [];
      if (v.selectTableData.length > 0) {
        v.selectTableData.map((item) => {
          ymsCarrierHandoverOrderIds.push(item.ymsCarrierHandoverOrderId);
        });
        v.axios.put(api.put_ymsCarrierHandoverOrder_updateDelivery, ymsCarrierHandoverOrderIds,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
            v.getHandoverPersonData(v.userInfoList);
            v.pageParamsStatus = true;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004040'));
        return false;
      }
    },
    // 单个标记出库
    singleMarkOut(ymsCarrierHandoverOrderId) {
      let v = this;
      v.axios.put(api.put_ymsCarrierHandoverOrder_batchUpdateDelivery + `${ymsCarrierHandoverOrderId}`, null,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.getHandoverPersonData(v.userInfoList);
          v.pageParamsStatus = true;
        }
      });
    },
    // 打印预交面单
    printPreDelivery(ymsCarrierHandoverOrderId) {
      let v = this;
      v.axios.put(api.put_ymsCarrierHandoverOrder_printHandoverPdfGetr + `${ymsCarrierHandoverOrderId}`, null,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.commonPrint(data, '1');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004041'));
            return false;
          }
        }
      });
    },
    // 获取物流商数据
    getLogisticsProvidersData() {
      let v = this;
      v.logisticsProviderData = [];
      v.axios.get(api.get_ymsCarrierHandoverOrder_queryCarrierHandover).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.unshift({
              carrierId: 'null',
              carrierName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
            });
            v.logisticsProviderData = data;
          }
        }
      });
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      this.$refs.dropDownFilter.inputValue = '';
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 判断是否是速卖通全托管虚拟物流
    isAliExpressLogistics(data, type) {
      let v = this;
      let talg = false;
      let carrierCode = '';
      let status = null;
      if (type === 1) {
        status = data.status === 0; // 已装箱
      } else {
        status = data.status === 0 || data.status === 1; // 已装箱、已出库
      }
      if (v.logisticsProviderData.length > 0) {
        v.logisticsProviderData.map((item) => {
          if (item.carrierId === data.carrierId) {
            carrierCode = item.carrierCode;
          }
        });
      }
      if (status && carrierCode === 'aliexpressChoice') {
        talg = true;
      }
      return talg;
    },
    // 预约揽收
    appointmentCollection(ymsCarrierHandoverOrderId) {
      let v = this;
      v.axios.put(api.put_ymsCarrierHandoverOrder_appointmentCollection + `${ymsCarrierHandoverOrderId}`, null,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004042'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 打印揽收面单
    printCollectionReceipt(ymsCarrierHandoverOrderId) {
      let v = this;
      v.axios.get(api.get_ymsCarrierHandoverOrder_printCollectionReceipt + `${ymsCarrierHandoverOrderId}`, null,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.commonPrint(data, '1');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004043'));
            return false;
          }
        }
      });
    }

  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    dropDownFilter,
    printCaseMarkModal
  }
};
</script>

<style scoped>

</style>
